module.exports = __webpack_public_path__ + "img/gy.41725ef9.svg";